<template>
    <div class="container" v-title="deputationName">
        <Navigation-bar v-scrollShadow="roll" :title="roll > titleHeight ? deputationName : ''">
        </Navigation-bar>
        <div class="container_content" v-show="pageShow">
            <div id="TeamAuditDetail" v-scroll="roll">
                <Pull-refresh 
                    v-model="pullRefresh.loading" 
                    loosing-text="释放刷新数据"
                    loading-text="正在刷新数据..." 
                    :success-text="pullRefresh.text" 
                    @refresh="onRefresh"
                >
                    <Title class="page_title">
                        <template slot="spreadhead">
                            <span>{{deputationName}}</span>
                        </template>
                        <template #subtitle>
                            <span>{{operatorName || operatorPhone}}已为您报名</span>
                        </template>
                    </Title>
                    <div class="list">
                        <ul>
                            <li v-for="(item,index) in groups" :key="index">
                                <div class="group_title">
                                    <div class="name">{{item.GroupInfo.Name}}</div>
                                    <div class="status" :class="{'error': [4,6,8].includes(item.GroupStatus)}" v-if="item.GroupStatus != null">{{statusText[item.GroupStatus]}}</div>
                                    <div v-else></div>
                                </div>
                                <div class="members">
                                    <ol>
                                        <li v-for="({
                                            baseInfo,
                                            RecordStatus
                                        },userIndex) in item.GroupUserList" :key="userIndex">
                                            <div class="member_info">
                                                <div class="member_img">
                                                    <img :src="getUserPhoto(baseInfo)" class="member_img">
                                                </div>
                                                <span>{{baseInfo.Name}}</span>
                                                <span class="status" :class="{'error': [4,6,8].includes(RecordStatus)}"  v-if="(item.GroupInfo.GroupType == 2 && RecordStatus != null) || (item.GroupInfo.GroupType == 3 && RecordStatus == 6)">（{{statusText[RecordStatus]}}）</span>
                                                <span v-else></span>
                                            </div>
                                            <div class="member_role">{{baseInfo.EnrollRoleList[0].RoleName}}{{baseInfo.JerseyNumber ? `(${baseInfo.JerseyNumber})` : ''}}</div>
                                        </li>
                                        <li v-if="item.GroupInfo.GroupType == 3 && item.GroupUserList.length == 1">
                                            <div class="member_info">
                                                <div class="member_img">
                                                    <img src="@/assets/images/icon/no_doubles@2x.png" class="member_img">
                                                </div>
                                                <span class="no">尚未匹配到队员</span>
                                            </div>
                                            <div></div>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                            <li v-if="otherUsers && otherUsers.length > 0">
                                <div class="group_title">
                                    <div class="name">其他人员</div>
                                    <div></div>
                                </div>
                                <div class="members">
                                    <ol>
                                        <li v-for="(item,index) in otherUsers" :key="index">
                                            <div class="member_info">
                                                <div class="member_img">
                                                    <img :src="getUserPhoto(item)" class="member_img">
                                                </div>
                                                <span>{{item.Name}}</span>
                                            </div>
                                            <div class="member_role">
                                                <template v-for="(roleItem,roleIndex) in item.EnrollRoleList">
                                                    <span :key="roleIndex">{{roleItem.RoleName}}</span>
                                                    <template v-if="roleIndex < item.EnrollRoleList.length - 1"> | </template>
                                                </template>
                                            </div>
                                        </li>
                                    </ol>
                                </div>
                            </li>
                        </ul>
                    </div>
                </Pull-refresh>
            </div>
        </div>
    </div>
</template>
<script>
import { PullRefresh } from 'vant';
import 'vant/lib/pull-refresh/style';
import {
    convertSize
} from '@js';
import {
    GetMyJoinDeputationEnrollRecordDetail//获取报名详情
} from '@/api';
export default {
    name:"LookTeamAuditDetail",
    components: {
        PullRefresh
    },
    data(){
        return{
            deputationEnrollId: 0,
            pageShow: false,
            roll:0,
            deputationName:"",
			operatorName: '',
			operatorPhone: '',
            groups:[],
            otherUsers:[],
            pullRefresh:{
                loading:false,
                text:''
            }
        }
    },
    created(){
        this.deputationEnrollId = +(this.$route.query.deputationEnrollId || 0);
        this.getData();
    },
    computed:{
		statusText(){
			return ['','未提交审核','组委会审核中','组委会审核中','审核有问题','公示中','公示有问题','报名成功','报名失败'];
		},
        titleHeight(){
            return convertSize(1.88);
        },
		portraitUnknown(){
			return require(`@images/portrait_unknown@3x.png`);
		},
		portraitMan(){
			return require(`@images/肖像_男@3x.png`);
		},
		portraitWoman(){
			return require(`@images/肖像_女@3x.png`);
		},
    },
    methods:{
		getUserPhoto(UserInfo){
			if(UserInfo.PhotolUrl){
				return UserInfo.PhotolUrl;
			}else if(UserInfo.Gender == 1){
				return this.portraitMan;
			}else if(UserInfo.Gender == 2){
				return this.portraitWoman;
			}
			return this.portraitUnknown;
		},
        getData(isRefresh){
            GetMyJoinDeputationEnrollRecordDetail({
                "DeputationEnrollId": this.deputationEnrollId,
            }).then(data=>{
                if(isRefresh){
                    this.pullRefresh.loading = false;
                    this.pullRefresh.text = data.Code == 0 ? "数据刷新成功" : "数据刷新失败";
                }
                if(data.Code == 0){
                    this.pageShow = true;
                    this.deputationName = data.DeputationName;
					this.operatorName = data.OperationUserName;
					this.operatorPhone = data.OperationUserPhone;
                    this.otherUsers = data.OtherUserList || [];
                    let GroupList = data.GroupList || [];
                    for(var i=0;i<GroupList.length;i++){
                        let {
                            GroupInfo,
                            GroupUserList
                        } = GroupList[i];
                        if(GroupInfo.GroupType == 1){
                            let {
                                RecordStatus
                            } = GroupUserList[0];
                            GroupList[i].GroupStatus = RecordStatus;
                        }else if(GroupInfo.GroupType == 3){
                            let {
                                PairEnrollStatus
                            } = GroupUserList[0].baseInfo;
                            GroupList[i].GroupStatus = PairEnrollStatus;
                        }
                    }
                    this.groups = GroupList;
                }
            }).catch(()=>{
                if(isRefresh){
                    this.pullRefresh.loading = false;
                    this.pullRefresh.text = "数据刷新失败";
                }
            })
        },
        onRefresh(){
            this.getData(true);
        },
    }
}
</script>
<style lang="scss" scoped>
.share{
    width: 48px;
    height: 48px;
    margin-right: -6px;
}
.list{
    padding: 0 40px;
    padding-bottom: 40px;
    box-sizing: border-box;
    ul>li{
        width: 100%;
        height: auto;
        padding: 12px 26px 8px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
        border-radius: 20px;
        margin-bottom: 24px;
        .group_title{
            width: 100%;
            min-height: 84px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px #F0F0F0 solid;
            .name{
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 500;
				line-height: 44px;
				word-break: break-all;
				padding: 20px 0;
				padding-right: 40px;
				box-sizing: border-box;
            }
            .status{
                font-size: 28px;
                font-weight: 400;
                color: #7E7E7F;
				white-space: nowrap;
                &.error{
                    color: #F06E43; 
                }
            }
        }
        .members{
            height: auto;
            ol{
                padding: 19px 0 16px;
                overflow: hidden;
                li{
                    height: 56px;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 16px;
                    &:last-of-type{
                        margin-bottom: 0;
                    }
                    .member_info{
                        display: flex;
                        align-items: center;
                        .member_img{
                            width: 56px;
                            height: 56px;
                            border-radius: 20px;
                            overflow: hidden;
                            display: flex;
                            align-items: center;
                            img{
                                width: 100%;
                            }
                        }
                        span{
                            font-size: 28px;
                            color: #1B1C1E;
                            font-weight: 400;
                            padding-left: 24px;
							&.no{
								color: #7E7E7F;
							}
                        }
                        .status{
                            font-size: 28px;
                            font-weight: 400;
                            color: #7E7E7F;
                            padding: 0;
                            &.error{
                                color: #F06E43; 
                            }
                        }
                    }
                    .member_role{
                        font-size: 28px;
                        color: #999999;
                        font-weight: 400;
                    }
                }
            }
            
        }
    }
}
</style>